/** Finds the task currently in progress for the calendar time indicator. */
import { useMemo } from 'react';
import { parseISO, addMinutes } from 'date-fns';
import { DEFAULT_TASK_DURATION_MINS } from '@/config/constants';
import useCurrentTime from '@/features/tasks/hooks/status/use-task-current-time.js';

export function useCalendarActiveTaskId(filteredTasks) {
  const currentTime = useCurrentTime();

  return useMemo(() => {
    if (!filteredTasks) return null;
    const now = currentTime;
    const currentTask = filteredTasks.find((task) => {
      if (!task.date || !task.time) return false;

      const startTime = task.date.toDate
        ? task.date.toDate()
        : parseISO(task.date);
      const [hours, minutes] = task.time.split(':').map(Number);
      startTime.setHours(hours, minutes);

      const endTime = addMinutes(
        startTime,
        task.duration || DEFAULT_TASK_DURATION_MINS,
      );

      return now >= startTime && now < endTime;
    });
    return currentTask ? currentTask.id : null;
  }, [currentTime, filteredTasks]);
}
